module.exports = __webpack_public_path__ + "img/logoHeader.98fba0de.png";